<style scoped>

</style>

<template>

  <v-container :style="{ pointerEvents: loading ? 'none' : 'all' }">

    <div v-show="loading" class="pt-5 overlay">
      <div class="text-xs-center">
        <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
        <h4>Loading Data</h4>
      </div>
    </div>

    <v-alert v-if="!chartData.length" class="" outline color="grey" icon="error_outline" :value="true">

      <p>
        No data found for this date range.
      </p>

      <p>
        Try another date range, or use the
        <router-link :to="`/station/${$route.params.id}/overview`">Station Overview</router-link>
        tab to determine the last known good data.
      </p>
    </v-alert>

    <v-container fluid>
      <v-layout wrap>
        <v-flex
          xs12 sm12 md6
          v-for="chart, index in chartData"
          :key="index"
        >
          <v-card class="ma-2">
            <div style="position: relative;">
              <chart :height="350" :chart-id="chart.id" :chart-data="chart.data" :options="chart.options"></chart>
            </div>
          </v-card>

        </v-flex>

      </v-layout>

    </v-container>

    <!--<v-card class="mb-4" v-for="chart, index in chartData" :key="index">-->
    <!--<chart :height="200" :chart-id="chart.id" :data="chart.data" :options="chart.options"></chart>-->
    <!--</v-card>-->

  </v-container>

</template>

<script>
  import favVars from '@/models/favorite-variables';
  import TimeSeries from '@/models/TimeSeries';
  import DateRange from '@/models/DateRange';
  import CONFIG from '@/config';
  import chartUtils from '@/utils/chart';
  import Chart from '@/components/Station/Chart';
  import randomColor from 'randomcolor';
  import { find, orderBy, minBy, maxBy } from 'lodash';
  // import colorUtility from 'warna';

  export default {

    name: 'StationObservations',

    components: {
      Chart,
    },

    data() {
      return {
        loading: false,
        chartData: [],
      };
    },

    mounted() {
      this.getData();
    },

    computed: {

      dateRange() {
        return this.$store.state.universal.dateRange;
      },

      stationObservations() {
        return this.$store.state.station.stationObservations;
      },

    },

    watch: {

      stationObservations(sensorVariable) {
        this.chartData = [];
        sensorVariable.forEach((sensorVar) => {
          const labels = chartUtils.buildLabels(sensorVar.range);
          const datasets = chartUtils.buildDatasets(sensorVar);

          const chartOptions = CONFIG.sensorVariableChartDefaults().options;

          chartOptions.title.text = sensorVar.label;
          chartOptions.legend.display = false;
          // chartOptions.scales.yAxes[0].ticks.min = minBy(datasets[0].data, 'y').y - 0.2;
          // chartOptions.scales.yAxes[0].ticks.max = maxBy(datasets[0].data, 'y').y + 0.2;
          chartOptions.scales.yAxes[0].scaleLabel.labelString = sensorVar.units;

          datasets.forEach((ds, ind) => {
            const color = randomColor({
              // hue: 'blue',    // red, orange, yellow, green, blue, purple, pink and monochrome
              luminosity: 'bright',    // bright, light or dark.
              seed: sensorVar.fulllabel + sensorVar.fulllabel.length.toString(),
            });
            datasets[ind].backgroundColor = color;
            datasets[ind].borderColor = color;
          });

          const fav = find(favVars, { name: sensorVar.name });

          this.chartData.push({
            id: sensorVar.name,
            order: fav.order,
            options: chartOptions,
            data: {
              labels,
              datasets,
            },
          });
        });

        this.chartData = orderBy(this.chartData, 'order');
      },

      $route: {
        deep: true,
        async handler() {
          this.getData();
        },

      },

    },

    methods: {

      async getData() {
        console.warn('get data');
        this.loading = true;
        const dateRange = new DateRange(this.dateRange.start, this.dateRange.end);

        const timeSeries = new TimeSeries({
          range: dateRange,
          vars: favVars.map(fav => fav.name).join(','),
          stids: this.$route.params.id,
        });

        const timeSeriesData = await timeSeries.loadData();

        if (timeSeriesData.timeseries.SUMMARY.NUMBER_OF_OBJECTS) {
          this.$store.dispatch('initializeStationObservations', {
            data: timeSeriesData,
            range: new DateRange(this.dateRange.start, this.dateRange.end),
          });
        }
        this.loading = false;
      },

    },

  };

</script>



// WEBPACK FOOTER //
// src/components/Station/Observations.vue